// @flow
import type { FieldType } from './FieldConfig';
import isDate from 'date-fns/is_date';
import format from 'date-fns/format';
import parse from 'date-fns/parse';

const VALUE_SEPERATOR = ' ';
const rangeEmptyValue = [1, 5];

export const getFieldEmptyValue = (type: FieldType): * => {
  if (type === 'select' || type === 'multiselect') {
    return undefined;
  }

  if (type === 'RatingRange') {
    return rangeEmptyValue;
  }

  if (type === 'date') {
    return null;
  }

  return '';
};

export const isFieldEmpty = (type: FieldType, value: *): boolean => {
  const emptyValue = getFieldEmptyValue(type);

  return value === emptyValue;
};

export const fieldDefault = (type: FieldType, value: *): * => {
  // if value is false return empty value
  if (value === null || typeof value === 'undefined') {
    return getFieldEmptyValue(type);
  }

  return value;
};

export const serializeField = (type: FieldType, value: *): string | number => {
  if (type === 'select' && typeof value === 'object') {
    return value.value;
  }

  if (type === 'multiselect' && Array.isArray(value)) {
    return value.map(v => serializeField('select', v)).join(VALUE_SEPERATOR);
  }

  if (type === 'RatingRange' && Array.isArray(value)) {
    return value.join('-');
  }

  if (type === 'number') {
    return Number(value);
  }

  if (type === 'date' && isDate(value)) {
    return format(value, 'YYYY-MM-DD');
  }

  return value;
};

export const deserializeField = (type: FieldType, value: string): * => {
  if (type === 'select') {
    return value.trim();
  }

  if (type === 'RatingRange') {
    const v = value.split('-');

    return v.length < 2 ? v.concat(v) : v.slice(0, 2);
  }

  if (type === 'multiselect') {
    return value.split(VALUE_SEPERATOR);
  }

  if (type === 'date') {
    return parse(value);
  }
};



// WEBPACK FOOTER //
// ./src/containers/search/SearchForm/fieldUtils.js